export enum OrderValidationErrorReason {
    UnknownError = "UnknownError",
    DealerNotFound = "DealerNotFound",
    DealerOnCreditHold = "DealerOnCreditHold",
    InvalidModelAndSerialNumber = "InvalidModelAndSerialNumber",
    InvalidPONumber = "InvalidPONumber",
    InvalidShippingAddress = "InvalidShippingAddress",
    InvalidShippingCode = "InvalidShippingCode",
    ItemDiscontinued = "ItemDiscontinued",
    ItemNotAvailable = "ItemNotAvailable",
    ItemQuantityMax = "ItemQuantityMax",
    ItemQuantityStock = "ItemQuantityStock",
    ItemQuantityEmergency = "ItemQuantityEmergency",
    InvalidItemNumber = "InvalidItemNumber",
    ItemNotOrderable = "ItemNotOrderable",
    ItemSoftFreeze = "ItemSoftFreeze",
    ItemHardFreeze = "ItemHardFreeze",
    ItemChannelAuthorization = "ItemChannelAuthorization",
    McfnetDown = "McfnetDown",
    BulkPricingAvailable = "BulkPricingAvailable",
    InvalidExxonMobilMixMatchQuantities = "InvalidExxonMobilMixMatchQuantities",
    InvalidSpectrumMixMatchQuantities = "InvalidSpectrumMixMatchQuantities",
    InvalidStarterBatteryMixMatchQuantities = "InvalidStarterBatteryMixMatchQuantities",
    ItemMinimumOrderQuantity = "ItemMinimumOrderQuantity",
    ItemCaseQuantity = "ItemCaseQuantity",
    MaterialNotListed = "MaterialNotListed",
    SoldToCustomerBlocked = "SoldToCustomerBlocked",
    SoldToMissing = "SoldToMissing",
    SoldToCustomerInvalid = "SoldToCustomerInvalid",
    ShipToCustomerBlocked = "ShipToCustomerBlocked",
    FinalToCustomerMissing = "FinalToCustomerMissing",
    MissingShipViaWarehouseCa = "MissingShipViaWarehouseCa",
    InvalidShipViaWarehouseIn = "InvalidShipViaWarehouseIn",
    InvalidFinalTo = "InvalidFinalTo",
    NoFinalToCustomer = "NoFinalToCustomer",
    ECCOPackageMixMatchTotalValue = "ECCOPackageMixMatchTotalValue",
    OfflineToSap = "OfflineToSap",
    PicCodeMinPriceAmount = "PicCodeMinPriceAmount",
    OfflineToWarehouseSystems = "OfflineToWarehouseSystems"
}
